import React from "react";
import { TYPE_PC } from "../../../common/defines";
import { customer_voice } from "../../../common/customer_voice";
import { Link } from "../../../lib/Link";
import { getUrl } from "../../../lib/masterUtil";

export const bike = ({ type }) => {
  return (
    <div className="tab_panel bike">
      <div className="characteristic">
        <div className="title_bike">
          <p>ハローバイクシリーズ</p>
        </div>
        <div className="bike_main_img">
          <img src="resource/img/kity.png" />
        </div>
        <div className="bike_table">
          <table>
            <tbody>
              <tr>
                <th></th>
                <td className="topleftborder">ボックスタイプ</td>
                <td className="whiteborder">パーキングタイプ</td>
                <td className="toprightborder">ガレージタイプ</td>
              </tr>
              <tr>
                <th className="topleftborder">雨風対策</th>
                <td><img src="resource/img/bike_icon1.png" /></td>
                <td><img src="resource/img/bike_icon2.png" /></td>
                <td><img src="resource/img/bike_icon1.png" /></td>
              </tr>
              <tr>
                <th>入口セキュリティ</th>
                <td><img src="resource/img/bike_icon1.png" /><br />（南京錠）</td>                
                <td><img src="resource/img/bike_icon3.png" /></td>
                <td><img src="resource/img/bike_icon1.png" /><br />（セキュリティカード）</td>
              </tr>
              <tr>
                <th>バリカー</th>
                <td><img src="resource/img/bike_icon3.png" /></td>
                <td><img src="resource/img/bike_icon1.png" /></td>
                <td><img src="resource/img/bike_icon2.png" /></td>
              </tr>
              <tr>
                <th>収納棚</th>
                <td><img src="resource/img/bike_icon2.png" /></td>
                <td><img src="resource/img/bike_icon3.png" /></td>
                <td><img src="resource/img/bike_icon2.png" /></td>
              </tr>
              <tr>
                <th>コンセント</th>
                <td><img src="resource/img/bike_icon2.png" /></td>
                <td><img src="resource/img/bike_icon3.png" /></td>
                <td><img src="resource/img/bike_icon2.png" /></td>
              </tr>
              <tr>
                <th>24時間利用</th>
                <td><img src="resource/img/bike_icon1.png" /></td>
                <td><img src="resource/img/bike_icon1.png" /></td>
                <td><img src="resource/img/bike_icon1.png" /></td>
              </tr>
              <tr>
                <th className="bottomleftborder">価格</th>
                <td><img src="resource/img/bike_icon2.png" /></td>
                <td><img src="resource/img/bike_icon1.png" /></td>
                <td className="bottomrightborder"><img src="resource/img/bike_icon3.png" /></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bike_one">
          <div className="bike_img">
            <img src="resource/img/bike1.jpg" />
          </div>
          <div className="bike_desc">
            <p className="bike_one_title">ボックスタイプ</p>
            <p className="bike_content">安全性、機能性、利便性を兼ね備えたボックスタイプの駐車場<br />
            ・二重ロックによる防犯性重視のセキュリティ<br />
            ・幅広いラダーレール（足を付けたまま乗り入れられます）<br />
            ・小物やヘルメット用の収納棚を完備<br />
            ・独立したボックスで、風雨による汚れや浸食も防止
            </p>
            <Link to={getUrl({ condition: { keyword: "ハローバイクボックス" } })} className="bike_btn">
              ボックスタイプを探す
            </Link>
          </div>
        </div>
        <div className="bike_one">
          <div className="bike_img">
            <img src="resource/img/bike2.jpg" />
          </div>
          <div className="bike_desc">
            <p className="bike_one_title">パーキングタイプ</p>
            <p className="bike_content">バリカー（盗難防止用にバイクをつなぐ車止め）設置の駐車場も多く、セキュリティ面にも配慮した青空タイプの駐車場<br />
            　・屋外駐輪場タイプ<br />
            　・リーズナブル<br />
            　・バリカー設置</p>
            <Link to={getUrl({ condition: { keyword: "ハローバイクパーキング" } })} className="bike_btn">
              パーキングタイプを探す
            </Link>
          </div>
        </div>
        <div className="bike_one">
          <div className="bike_img">
            <img src="resource/img/bike3.jpg" />
          </div>
          <div className="bike_desc">
            <p className="bike_one_title">ガレージタイプ</p>
            <p className="bike_content">屋内スペースを共同で利用するガレージタイプのバイク駐車場<br />　・電動シャッター<br />
              　・防犯カメラ付き<br />
              　・専用キーによる認証セキュリティ完備。<br />
              　・電源コンセント設置<br />　・バイク装備品収納可能なロッカー設置（別料金）</p>
              <Link to={getUrl({ condition: { keyword: "ハローバイクガレージ" } })} className="bike_btn">
              ガレージタイプを探す
            </Link>
          </div>
        </div>
        <div className="text">
           ※設備ついては物件により相違することがございますのでご確認ください。
        </div>
      </div>
      {type === TYPE_PC ? customer_voice(type, true) : ""}
    </div>
  );
}



// WEBPACK FOOTER //
// ./pages/new/lineup/bike.jsx